import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any[] = []
const gridColumnsSlice = createSlice({
  name: 'gridColumns',
  initialState,
  reducers: {
    updateGridColumns: (state, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})
export const gridColumnsAction = gridColumnsSlice.actions

export default gridColumnsSlice
